import { useMemo } from 'react';
const useBlastActions = (status) => useMemo(() => {
    if (!status) {
        return {
            canEdit: false,
            canValidate: false,
            canPublish: false,
            canSchedule: false,
            canCancel: false,
            canResume: false
        };
    }
    return {
        canEdit: status === 'DRAFT',
        canValidate: status === 'DRAFT',
        canPublish: status === 'DRAFT' || status === 'SCHEDULED',
        canSchedule: status === 'DRAFT' || status === 'SCHEDULED',
        canCancel: status === 'SCHEDULED' || status === 'SENDING',
        canResume: status === 'FAILED'
    };
}, [status]);
export default useBlastActions;
